export const MAIN_MENU_SEGMENT = "MainMenuSegment";

export default {
    MAIN_MENU_SEGMENT,
};
